module.exports = __webpack_public_path__ + "img/Weak Spring.1526e235.png";